import { Link } from '../i18n/routing';
import SEOHead from '../components/SEOHead';

/**
 * Rendered for any URL that isn't a real route. The server still answers 200
 * (single-page-app fallback), so the page tells Google not to index it instead
 * of silently showing the homepage under a made-up URL.
 */
export default function NotFoundPage() {
  const links = [
    { to: '/', label: 'Home' },
    { to: '/pricing', label: 'Pricing' },
    { to: '/blog', label: 'Blog' },
    { to: '/help-center', label: 'Help Center' },
    { to: '/contact', label: 'Contact us' },
  ];
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4 py-24">
      <SEOHead
        title="Page not found | TrainZilla"
        description="This page doesn't exist. Head back to the TrainZilla homepage, pricing or blog."
        noindex
      />
      <p className="text-sm font-semibold mb-3" style={{ color: 'var(--accent-indigo)' }}>404</p>
      <h1 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: 'var(--text-primary)' }}>
        We couldn&apos;t find that page
      </h1>
      <p className="mb-8 max-w-md" style={{ color: 'var(--text-secondary)' }}>
        The link may be old or mistyped. Try one of these instead:
      </p>
      <div className="flex flex-wrap gap-3 justify-center">
        {links.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            className="px-4 py-2 rounded-lg text-sm font-semibold border"
            style={{ borderColor: 'var(--border-color)', color: 'var(--text-primary)' }}
          >
            {l.label}
          </Link>
        ))}
      </div>
    </div>
  );
}
